(function () {
  const sliders = document.querySelectorAll('.range-slider');

  if (!sliders.length) {
    return;
  }

  const STORAGE_KEY = 'vtx-font-scale';
  // `html` is set to font-size: 62.5% in _global.scss (1rem === 10px baseline).
  // Sliding up increases that percentage, scaling every rem-based size on the site up to 87.5%.
  const BASE_FONT_SIZE = 62.5;
  const MAX_INCREASE = 25;

  function applyFontScale(value) {
    const percentage = BASE_FONT_SIZE + (value / 100) * MAX_INCREASE;
    document.documentElement.style.fontSize = `${percentage}%`;
  }

  const storedValue = window.localStorage.getItem(STORAGE_KEY);
  const initialValue = storedValue !== null ? Number(storedValue) : Number(sliders[0].value);

  applyFontScale(initialValue);

  sliders.forEach((slider) => {
    slider.value = initialValue;

    slider.addEventListener('input', () => {
      const value = Number(slider.value);
      applyFontScale(value);
      window.localStorage.setItem(STORAGE_KEY, value);

      sliders.forEach((otherSlider) => {
        if (otherSlider !== slider) {
          otherSlider.value = value;
        }
      });
    });
  });
})();
